import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { PasswordInput } from '@ebsco-ui/ebsco-ui';

import { FieldWrapper } from './FieldWrapper';
import { FieldProps } from './constants';

export const PasswordField = (props: FieldProps): ReactElement => {
  const { $t } = useIntl();

  return (
    <FieldWrapper
      showPasswordButtonText={$t({
        id: 'login.hide',
        defaultMessage: 'Hide',
      })}
      hidePasswordButtonText={$t({
        id: 'login.show',
        defaultMessage: 'Show',
      })}
      component={PasswordInput}
      data-auto={props.name}
      {...props}
    />
  );
};
